<cv-generic-identifier-list
	[listTitle]="'Client Identifier'"
	[labelAddButton]="'Add Client Identifier'"
	[identifierLabel]="'Generic Integration Client Name'"
	[secondFieldLabel]="'Integration Client Id'"
	[showSecondField]="true"
	[showSecondFieldOnCreate]="true"
	[disableSecondFieldInEdit]="false"
	[integrationName]="integrationName"
	[service]="clientService"
	[broadcastEvent]="ADD_EDIT_CLIENT_IDENTIFIER"
	[getListFn]="getListFn"
	[deleteFn]="deleteFn"
	[secondFieldName]="'integrationClientId'"
	[getSecondFieldValue]="getSecondFieldValue"
	[modelFactory]="modelFactory">
</cv-generic-identifier-list>
